import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import { FaBars, FaMoon, FaSun, FaLanguage, FaUserShield } from 'react-icons/fa';
import { useTheme } from '../contexts/ThemeContext';
import { useLanguage } from '../contexts/LanguageContext';
import { useAuth } from '../contexts/AuthContext';
import Calendar from '../components/public/Calendar';
import LanguageSelector from '../components/public/LanguageSelector';
import BottomNav from '../components/public/BottomNav';
import SideMenu from '../components/public/SideMenu';
import logo from '../assets/logo.svg';
import './Home.css';

const Home = () => {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();
  const { setShowLanguageModal } = useLanguage();
  const { isAuthenticated, logout } = useAuth();
  const [showSideMenu, setShowSideMenu] = useState(false);
  const navigate = useNavigate();

  return (
    <div className="home-page">
      {/* Header is now hidden - logo and menu moved to bottom nav */}
      
      <main className="main-content full-height">
        <Calendar />
      </main>

      <BottomNav 
        activeTab="calendar" 
        logo={logo}
        onMenuClick={() => setShowSideMenu(true)}
        onLanguageClick={() => navigate('/languages')}
        onThemeClick={toggleTheme}
        theme={theme}
        isAuthenticated={isAuthenticated}
        onLogout={logout}
        t={t}
      />
      <SideMenu isOpen={showSideMenu} onClose={() => setShowSideMenu(false)} />
      <LanguageSelector />
    </div>
  );
};

export default Home;
